import React from "react";
import { PrestacaoContasTiposPage } from "./prestacaoContasTipos.page";
import { PrestacaoContasTiposProvider } from "./context/prestacao-contas-tipos-context";

export function PrestacaoContasTiposFactory() {
    return (
        <PrestacaoContasTiposProvider>
            <PrestacaoContasTiposPage></PrestacaoContasTiposPage>
        </PrestacaoContasTiposProvider>
    );
}
